<template>
  <main class="vh-100">
    <CardContainer :cardHeader="cardHeader" :cardFooter="cardFooter">
      <InputsContainer />
    </CardContainer>
  </main>
</template>
<script>
import { CardContainer } from "@/containers/exporter.js";
import InputsContainer from "./InputsContainer.vue";

export default {
  name: "main",
  data() {
    return {
      cardHeader: {
        title: "Reset Password",
        subTitle: "Please Reset your Password.",
      },
      cardFooter: {
        paragraphText: "Return to",
        buttonText: "Sign In",
        buttonClick: () => {
          this.$router.push({ path: "signin" });
        },
      },
    };
  },
  components: {
    CardContainer,
    InputsContainer,
  },
};
</script>
